// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
___CSS_LOADER_EXPORT___.push([module.id, "@import url(https://fonts.googleapis.com/css2?family=Poppins:wght@400;600;700&display=swap);"]);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `

.word-wizard-game-container {
    display: flex;
    flex-direction: column;
    align-items: center;
    padding: 30px;
    max-width: 850px;
    width: 100%;
    margin: 20px auto;
}

.game-main-title {
    font-family: 'Montserrat', sans-serif; /* Distinctive title font */
    font-size: 3.8em;
    font-weight: 700;
    color: #2c3e50; /* Deep blue */
    text-shadow: 2px 2px 5px rgba(0, 0, 0, 0.1);
    margin-bottom: 30px;
    letter-spacing: 1.5px;
}

.game-board-panel {
    background-color: #ffffff;
    border-radius: 15px;
    box-shadow: 0 10px 30px rgba(0, 0, 0, 0.1);
    padding: 40px;
    width: 100%;
    text-align: center;
    position: relative;
    overflow: hidden;
}

/* Subtle gradient border effect */
.game-board-panel::before {
    content: '';
    position: absolute;
    top: 0;
    left: 0;
    right: 0;
    bottom: 0;
    border-radius: 15px;
    padding: 4px; /* Thickness of the border */
    background: linear-gradient(45deg, #42a5f5, #26a69a); /* Blue-green gradient */
    -webkit-mask:
       linear-gradient(#fff 0 0) content-box,
       linear-gradient(#fff 0 0);
    mask-composite: exclude;
    z-index: -1;
}

/* --- Common Button Styles --- */
.primary-button, .action-button, .difficulty-button, .letter-tile {
    font-family: 'Montserrat', sans-serif;
    font-weight: 600;
    border: none;
    padding: 12px 25px;
    border-radius: 8px;
    cursor: pointer;
    transition: all 0.2s ease;
    text-transform: uppercase;
    letter-spacing: 0.5px;
}

.primary-button {
    background-color: #28a745; /* Green */
    color: white;
    font-size: 1.2em;
    box-shadow: 0 4px 10px rgba(40, 167, 69, 0.3);
}

.primary-button:hover {
    background-color: #218838; /* Darker green */
    transform: translateY(-2px);
    box-shadow: 0 6px 15px rgba(40, 167, 69, 0.4);
}

.primary-button:active {
    transform: translateY(1px);
    box-shadow: 0 2px 5px rgba(40, 167, 69, 0.2);
}

.action-button {
    background-color: #42a5f5; /* Light blue */
    color: white;
    font-size: 1em;
    box-shadow: 0 3px 8px rgba(66, 165, 245, 0.3);
}

.action-button:hover {
    background-color: #2196f3; /* Darker blue */
    transform: translateY(-1px);
    box-shadow: 0 4px 12px rgba(66, 165, 245, 0.4);
}

.action-button:active {
    transform: translateY(0);
    box-shadow: 0 1px 3px rgba(66, 165, 245, 0.2);
}

/* --- Game Menu --- */
.game-menu-screen {
    padding: 20px 0;
}

.menu-title {
    font-size: 2.2em;
    color: #26a69a; /* Teal */
    margin-bottom: 25px;
    font-weight: 600;
}

.difficulty-options {
    display: flex;
    justify-content: center;
    gap: 15px;
    margin-bottom: 30px;
    flex-wrap: wrap;
}

.difficulty-button {
    background-color: #bdbdbd; /* Light gray */
    color: #555;
    font-size: 1.1em;
    padding: 10px 20px;
    box-shadow: 0 2px 5px rgba(0, 0, 0, 0.1);
}

.difficulty-button:hover {
    background-color: #9e9e9e; /* Medium gray */
    transform: translateY(-1px);
}

.difficulty-button.active {
    background-color: #42a5f5; /* Active blue */
    color: white;
    box-shadow: 0 3px 8px rgba(66, 165, 245, 0.3);
    transform: translateY(0);
}
.difficulty-button.active:hover {
    background-color: #42a5f5; /* No change on hover for active */
}

.difficulty-description {
    font-size: 1em;
    color: #616161;
    margin-bottom: 40px;
    line-height: 1.5;
}

/* --- Game Active Area --- */
.game-active-area {
    padding: 0 10px;
}

.game-header-stats {
    display: flex;
    justify-content: space-around;
    margin-bottom: 30px;
    background-color: #eceff1; /* Very light blue-gray */
    padding: 15px 20px;
    border-radius: 10px;
    box-shadow: inset 0 1px 5px rgba(0, 0, 0, 0.05);
}

.stat-box {
    display: flex;
    flex-direction: column;
    align-items: center;
}

.stat-label {
    font-size: 0.9em;
    color: #78909c;
    margin-bottom: 5px;
    font-weight: 400;
}

.stat-value {
    font-size: 1.8em;
    font-weight: 700;
    color: #26a69a; /* Teal */
}

.timer-box .stat-value.time-critical {
    color: #ef5350; /* Red */
    animation: pulse-warn 1s infinite alternate;
}

@keyframes pulse-warn {
    from { opacity: 1; }
    to { opacity: 0.7; }
}

/* Scrambled Letters Tray */
.scrambled-letters-tray {
    display: flex;
    justify-content: center;
    flex-wrap: wrap;
    gap: 10px;
    margin-bottom: 30px;
    min-height: 70px; /* To prevent layout jump */
}

.letter-tile {
    background-color: #bbdefb; /* Lighter blue */
    color: #1e88e5; /* Darker blue text */
    font-size: 1.8em;
    min-width: 55px;
    height: 55px;
    display: flex;
    align-items: center;
    justify-content: center;
    padding: 0;
    border-radius: 8px;
    box-shadow: 0 2px 5px rgba(0, 0, 0, 0.1);
    font-weight: 700;
}

.letter-tile:hover:not(:disabled) {
    background-color: #90caf9; /* Even lighter blue */
    transform: translateY(-2px);
    box-shadow: 0 4px 8px rgba(0, 0, 0, 0.2);
}

.letter-tile.used {
    background-color: #e0e0e0; /* Gray for used letters */
    color: #9e9e9e;
    cursor: not-allowed;
    opacity: 0.7;
    transform: none;
    box-shadow: none;
}

/* Word Input Controls */
.word-input-controls {
    display: flex;
    flex-direction: column;
    align-items: center;
    margin-bottom: 25px;
}

.word-input-field {
    width: 80%;
    max-width: 400px;
    padding: 12px 18px;
    margin-bottom: 15px;
    border: 1px solid #cfd8dc;
    border-radius: 8px;
    font-size: 1.2em;
    text-align: center;
    outline: none;
    transition: border-color 0.3s ease, box-shadow 0.3s ease;
    color: #34495e;
    text-transform: uppercase;
    font-weight: 400;
}

.word-input-field::placeholder {
    color: #b0bec5;
    font-weight: 300;
}

.word-input-field:focus {
    border-color: #42a5f5;
    box-shadow: 0 0 0 3px rgba(66, 165, 245, 0.2);
}

.input-action-buttons {
    display: flex;
    gap: 15px;
    flex-wrap: wrap;
    justify-content: center;
}

.submit-button {
    background-color: #66bb6a; /* Green */
}
.submit-button:hover {
    background-color: #43a047; /* Darker green */
}

.clear-button {
    background-color: #90a4ae; /* Gray */
}
.clear-button:hover {
    background-color: #78909c; /* Darker gray */
}

/* Game Feedback Messages */
.game-feedback-message {
    font-size: 1.1em;
    padding: 10px 20px;
    border-radius: 6px;
    margin-bottom: 20px;
    min-height: 25px; /* Maintain space */
    transition: background-color 0.3s ease, color 0.3s ease;
    font-weight: 500;
}

.game-feedback-message.success {
    background-color: #e8f5e9; /* Light green background */
    color: #28a745;
    border: 1px solid #a5d6a7;
}

.game-feedback-message.warning {
    background-color: #fffde7; /* Light yellow background */
    color: #ffc107;
    border: 1px solid #ffe082;
}

.game-feedback-message.error {
    background-color: #ffebee; /* Light red background */
    color: #ef5350;
    border: 1px solid #ef9a9a;
}

/* Found Words Display */
.found-words-display {
    background-color: #f5f5f5; /* Lighter gray background */
    padding: 20px;
    border-radius: 10px;
    box-shadow: inset 0 1px 5px rgba(0, 0, 0, 0.03);
    margin-top: 25px;
}

.found-words-title {
    font-size: 1.5em;
    color: #2c3e50;
    margin-bottom: 15px;
    font-weight: 600;
}

.found-words-list-scroll {
    list-style: none;
    padding: 0;
    display: flex;
    flex-wrap: wrap;
    justify-content: center;
    gap: 8px;
    max-height: 120px; /* Fixed height for scrolling */
    overflow-y: auto;
    border-top: 1px dashed #cfd8dc;
    padding-top: 15px;
    /* Custom scrollbar styles */
    scrollbar-width: thin; /* Firefox */
    scrollbar-color: #90a4ae #f5f5f5; /* Firefox */
}

.found-words-list-scroll::-webkit-scrollbar {
    width: 8px;
}
.found-words-list-scroll::-webkit-scrollbar-track {
    background: #f5f5f5;
    border-radius: 10px;
}
.found-words-list-scroll::-webkit-scrollbar-thumb {
    background-color: #90a4ae;
    border-radius: 10px;
    border: 2px solid #f5f5f5;
}

.found-word-item {
    background-color: #e0f2f7; /* Very light blue */
    color: #2c3e50;
    padding: 6px 12px;
    border-radius: 15px;
    font-size: 0.95em;
    font-weight: 400;
    box-shadow: 0 1px 3px rgba(0, 0, 0, 0.08);
    text-transform: capitalize;
}

/* --- Game Over Screen --- */
.game-over-screen {
    padding: 30px 0;
}

.game-over-title {
    font-size: 2.8em;
    color: #ef5350; /* Red */
    margin-bottom: 20px;
    font-weight: 700;
    text-shadow: 1px 1px 3px rgba(0, 0, 0, 0.1);
}

.final-summary {
    font-size: 1.4em;
    color: #34495e;
    margin-bottom: 10px;
}

.final-score-value, .final-words-count-value {
    font-weight: 700;
    color: #26a69a; /* Teal */
    font-size: 1.1em;
}

.play-again-button {
    margin-top: 30px;
}

/* Responsive Adjustments */
@media (max-width: 768px) {
    .game-main-title {
        font-size: 3em;
    }
    .game-board-panel {
        padding: 30px;
    }
    .menu-title, .game-over-title {
        font-size: 2em;
    }
    .stat-value {
        font-size: 1.6em;
    }
    .letter-tile {
        font-size: 1.5em;
        min-width: 50px;
        height: 50px;
    }
    .word-input-field {
        font-size: 1.1em;
        padding: 10px 15px;
    }
    .action-button {
        font-size: 0.9em;
        padding: 10px 20px;
    }
    .final-summary {
        font-size: 1.2em;
    }
}

@media (max-width: 480px) {
    .word-wizard-game-container {
        padding: 15px;
    }
    .game-main-title {
        font-size: 2.2em;
        margin-bottom: 20px;
    }
    .game-board-panel {
        padding: 20px;
    }
    .difficulty-options {
        flex-direction: column;
        gap: 8px;
    }
    .menu-title, .game-over-title {
        font-size: 1.6em;
    }
    .stat-value {
        font-size: 1.4em;
    }
    .letter-tile {
        font-size: 1.2em;
        min-width: 45px;
        height: 45px;
    }
    .word-input-field {
        width: 95%;
    }
    .input-action-buttons {
        flex-direction: column;
        gap: 10px;
    }
    .action-button {
        width: 100%;
        max-width: 180px;
    }
    .final-summary {
        font-size: 1em;
    }
}






/*    ========================================================= memory match css========================================================= */




/* --- Global Styles & Typography --- */

:root {
    --bg-color: #f0f4f8; /* Light blue-gray background */
    --primary-color: #4a90e2; /* A friendly, vibrant blue */
    --secondary-color: #50e3c2; /* A complementary teal/mint */
    --dark-text-color: #333;
    --light-text-color: #fff;
    --card-bg: #ffffff;
    --card-matched-bg: #d4edda; /* Soft green for matched cards */
    --card-matched-border: #b2d8b6;
    --shadow-color: rgba(0, 0, 0, 0.1);
}



/* --- Main Game Container --- */
.memory-match-container {
   
    text-align: center;
       display: flex;
    flex-direction: column;
    align-items: center;
    padding: 30px;
    /* max-width: 850px; */
    width: 100%;
    margin: 20px auto;
}

.game-title {
    font-size: 2.5rem;
    font-weight: 700;
    color: var(--primary-color);
    margin-bottom: 20px;
    text-shadow: 1px 1px 2px var(--shadow-color);
}

.game-board {
    background: var(--light-text-color);
    padding: 100px;
    border-radius: 20px;
    box-shadow: 0 10px 30px var(--shadow-color);
    min-height: 500px; /* Ensure consistent height */
    display: flex;
    flex-direction: column;
    justify-content: center;
}

/* --- Game Screens (Menu & Win) --- */
.game-screen {
    display: flex;
    flex-direction: column;
    align-items: center;
    justify-content: center;
    animation: fadeIn 0.5s ease-in-out;
}

.screen-title {
    font-size: 2rem;
    font-weight: 600;
    margin-bottom: 20px;
}

.win-message {
    font-size: 1.2rem;
    margin-bottom: 20px;
}

.win-stats {
    background: #f9f9f9;
    padding: 15px 30px;
    border-radius: 10px;
    margin-bottom: 30px;
    text-align: left;
}

.win-stats p {
    margin: 8px 0;
    font-size: 1.1rem;
}


/* --- Difficulty Selection --- */
.difficulty-options {
    display: flex;
    gap: 15px;
    margin-bottom: 20px;
}

.difficulty-button {
    background: #e9ecef;
    border: 2px solid transparent;
    border-radius: 10px;
    padding: 12px 25px;
    font-size: 1rem;
    font-weight: 600;
    cursor: pointer;
    transition: all 0.3s ease;
}

.difficulty-button:hover {
    background: #dde2e6;
}

.difficulty-button.active {
    background-color: var(--secondary-color);
    color: var(--light-text-color);
    border-color: var(--secondary-color);
}

.difficulty-description {
    font-style: italic;
    color: #6c757d;
    min-height: 40px; /* Prevent layout shift */
    margin-bottom: 25px;
}


/* --- Buttons --- */
.primary-button {
    background-color: var(--primary-color);
    color: var(--light-text-color);
    border: none;
    border-radius: 10px;
    padding: 15px 40px;
    font-size: 1.1rem;
    font-weight: 600;
    cursor: pointer;
    transition: background-color 0.3s ease, transform 0.2s ease;
}

.primary-button:hover {
    background-color: #3a7ac8;
    transform: translateY(-2px);
}

.secondary-button {
    background: #f8f9fa;
    color: var(--dark-text-color);
    border: 1px solid #dee2e6;
    border-radius: 8px;
    padding: 8px 16px;
    font-weight: 600;
    cursor: pointer;
    transition: background-color 0.3s ease;
}

.secondary-button:hover {
    background-color: #e9ecef;
}

/* --- Game Info Bar --- */
.game-info-bar {
    display: flex;
    justify-content: space-between;
    align-items: center;
    padding: 0 10px;
    margin-bottom: 25px;
    font-size: 1.1rem;
}

.info-value {
    font-weight: 700;
    color: var(--primary-color);
}

/* --- Card Grid & Card Styles --- */
.card-grid {
    display: grid;
    gap: 15px;
    justify-content: center;
}

.card-container {
    perspective: 1000px; /* For the 3D flip effect */
}

.card-inner {
    position: relative;
    width: 100%;
    aspect-ratio: 1 / 1; /* Makes cards perfectly square */
    transform-style: preserve-3d;
    transition: transform 0.6s cubic-bezier(0.4, 0, 0.2, 1);
    background: none;
    border: none;
    padding: 0;
    cursor: pointer;
}

.card-inner.is-flipped {
    transform: rotateY(180deg);
}

.card-face {
    position: absolute;
    width: 100%;
    height: 100%;
    backface-visibility: hidden;
    -webkit-backface-visibility: hidden; /* Safari */
    display: flex;
    justify-content: center;
    align-items: center;
    border-radius: 10px;
    box-shadow: 0 4px 8px var(--shadow-color);
    font-size: 2rem; /* Default size for icons */
}

.card-back {
    background: linear-gradient(135deg, var(--primary-color), var(--secondary-color));
    color: var(--light-text-color);
}

.card-front {
    background-color: var(--card-bg);
    color: var(--dark-text-color);
    transform: rotateY(180deg);
}

/* Matched Card Styles */
.card-inner.is-matched .card-front {
    background-color: var(--card-matched-bg);
    border: 2px solid var(--card-matched-border);
    color: #388e3c; /* Darker green for icon */
    transform: rotateY(180deg) scale(1.05); /* Slight pop effect */
    transition: background-color 0.3s ease, transform 0.3s ease;
}

.card-inner.is-matched {
    cursor: not-allowed;
    opacity: 0.8;
}

/* Adjust font size for smaller cards in harder difficulties */
@media (max-width: 768px) {
    .card-face {
        font-size: 1.8rem;
    }
    .game-title {
        font-size: 2rem;
    }
    .game-board {
        padding: 20px;
    }
}

@media (max-width: 480px) {
    body {
        padding: 10px;
    }
    .card-face {
        font-size: 1.5rem;
    }
     .difficulty-options {
        flex-direction: column;
    }
    .game-info-bar {
        flex-direction: column;
        gap: 10px;
        margin-bottom: 20px;
    }
}

/* --- Animations --- */
@keyframes fadeIn {
    from {
        opacity: 0;
        transform: translateY(10px);
    }
    to {
        opacity: 1;
        transform: translateY(0);
    }
}
`, "",{"version":3,"sources":["webpack://./src/newtest/game/game.css"],"names":[],"mappings":";;AAEA;IACI,aAAa;IACb,sBAAsB;IACtB,mBAAmB;IACnB,aAAa;IACb,gBAAgB;IAChB,WAAW;IACX,iBAAiB;AACrB;;AAEA;IACI,qCAAqC,EAAE,2BAA2B;IAClE,gBAAgB;IAChB,gBAAgB;IAChB,cAAc,EAAE,cAAc;IAC9B,2CAA2C;IAC3C,mBAAmB;IACnB,qBAAqB;AACzB;;AAEA;IACI,yBAAyB;IACzB,mBAAmB;IACnB,0CAA0C;IAC1C,aAAa;IACb,WAAW;IACX,kBAAkB;IAClB,kBAAkB;IAClB,gBAAgB;AACpB;;AAEA,kCAAkC;AAClC;IACI,WAAW;IACX,kBAAkB;IAClB,MAAM;IACN,OAAO;IACP,QAAQ;IACR,SAAS;IACT,mBAAmB;IACnB,YAAY,EAAE,4BAA4B;IAC1C,oDAAoD,EAAE,wBAAwB;IAC9E;;gCAE4B;IAE5B,uBAAuB;IACvB,WAAW;AACf;;AAEA,iCAAiC;AACjC;IACI,qCAAqC;IACrC,gBAAgB;IAChB,YAAY;IACZ,kBAAkB;IAClB,kBAAkB;IAClB,eAAe;IACf,yBAAyB;IACzB,yBAAyB;IACzB,qBAAqB;AACzB;;AAEA;IACI,yBAAyB,EAAE,UAAU;IACrC,YAAY;IACZ,gBAAgB;IAChB,6CAA6C;AACjD;;AAEA;IACI,yBAAyB,EAAE,iBAAiB;IAC5C,2BAA2B;IAC3B,6CAA6C;AACjD;;AAEA;IACI,0BAA0B;IAC1B,4CAA4C;AAChD;;AAEA;IACI,yBAAyB,EAAE,eAAe;IAC1C,YAAY;IACZ,cAAc;IACd,6CAA6C;AACjD;;AAEA;IACI,yBAAyB,EAAE,gBAAgB;IAC3C,2BAA2B;IAC3B,8CAA8C;AAClD;;AAEA;IACI,wBAAwB;IACxB,6CAA6C;AACjD;;AAEA,sBAAsB;AACtB;IACI,eAAe;AACnB;;AAEA;IACI,gBAAgB;IAChB,cAAc,EAAE,SAAS;IACzB,mBAAmB;IACnB,gBAAgB;AACpB;;AAEA;IACI,aAAa;IACb,uBAAuB;IACvB,SAAS;IACT,mBAAmB;IACnB,eAAe;AACnB;;AAEA;IACI,yBAAyB,EAAE,eAAe;IAC1C,WAAW;IACX,gBAAgB;IAChB,kBAAkB;IAClB,wCAAwC;AAC5C;;AAEA;IACI,yBAAyB,EAAE,gBAAgB;IAC3C,2BAA2B;AAC/B;;AAEA;IACI,yBAAyB,EAAE,gBAAgB;IAC3C,YAAY;IACZ,6CAA6C;IAC7C,wBAAwB;AAC5B;AACA;IACI,yBAAyB,EAAE,kCAAkC;AACjE;;AAEA;IACI,cAAc;IACd,cAAc;IACd,mBAAmB;IACnB,gBAAgB;AACpB;;AAEA,6BAA6B;AAC7B;IACI,eAAe;AACnB;;AAEA;IACI,aAAa;IACb,6BAA6B;IAC7B,mBAAmB;IACnB,yBAAyB,EAAE,yBAAyB;IACpD,kBAAkB;IAClB,mBAAmB;IACnB,+CAA+C;AACnD;;AAEA;IACI,aAAa;IACb,sBAAsB;IACtB,mBAAmB;AACvB;;AAEA;IACI,gBAAgB;IAChB,cAAc;IACd,kBAAkB;IAClB,gBAAgB;AACpB;;AAEA;IACI,gBAAgB;IAChB,gBAAgB;IAChB,cAAc,EAAE,SAAS;AAC7B;;AAEA;IACI,cAAc,EAAE,QAAQ;IACxB,2CAA2C;AAC/C;;AAEA;IACI,OAAO,UAAU,EAAE;IACnB,KAAK,YAAY,EAAE;AACvB;;AAEA,2BAA2B;AAC3B;IACI,aAAa;IACb,uBAAuB;IACvB,eAAe;IACf,SAAS;IACT,mBAAmB;IACnB,gBAAgB,EAAE,2BAA2B;AACjD;;AAEA;IACI,yBAAyB,EAAE,iBAAiB;IAC5C,cAAc,EAAE,qBAAqB;IACrC,gBAAgB;IAChB,eAAe;IACf,YAAY;IACZ,aAAa;IACb,mBAAmB;IACnB,uBAAuB;IACvB,UAAU;IACV,kBAAkB;IAClB,wCAAwC;IACxC,gBAAgB;AACpB;;AAEA;IACI,yBAAyB,EAAE,sBAAsB;IACjD,2BAA2B;IAC3B,wCAAwC;AAC5C;;AAEA;IACI,yBAAyB,EAAE,0BAA0B;IACrD,cAAc;IACd,mBAAmB;IACnB,YAAY;IACZ,eAAe;IACf,gBAAgB;AACpB;;AAEA,wBAAwB;AACxB;IACI,aAAa;IACb,sBAAsB;IACtB,mBAAmB;IACnB,mBAAmB;AACvB;;AAEA;IACI,UAAU;IACV,gBAAgB;IAChB,kBAAkB;IAClB,mBAAmB;IACnB,yBAAyB;IACzB,kBAAkB;IAClB,gBAAgB;IAChB,kBAAkB;IAClB,aAAa;IACb,wDAAwD;IACxD,cAAc;IACd,yBAAyB;IACzB,gBAAgB;AACpB;;AAEA;IACI,cAAc;IACd,gBAAgB;AACpB;;AAEA;IACI,qBAAqB;IACrB,6CAA6C;AACjD;;AAEA;IACI,aAAa;IACb,SAAS;IACT,eAAe;IACf,uBAAuB;AAC3B;;AAEA;IACI,yBAAyB,EAAE,UAAU;AACzC;AACA;IACI,yBAAyB,EAAE,iBAAiB;AAChD;;AAEA;IACI,yBAAyB,EAAE,SAAS;AACxC;AACA;IACI,yBAAyB,EAAE,gBAAgB;AAC/C;;AAEA,2BAA2B;AAC3B;IACI,gBAAgB;IAChB,kBAAkB;IAClB,kBAAkB;IAClB,mBAAmB;IACnB,gBAAgB,EAAE,mBAAmB;IACrC,uDAAuD;IACvD,gBAAgB;AACpB;;AAEA;IACI,yBAAyB,EAAE,2BAA2B;IACtD,cAAc;IACd,yBAAyB;AAC7B;;AAEA;IACI,yBAAyB,EAAE,4BAA4B;IACvD,cAAc;IACd,yBAAyB;AAC7B;;AAEA;IACI,yBAAyB,EAAE,yBAAyB;IACpD,cAAc;IACd,yBAAyB;AAC7B;;AAEA,wBAAwB;AACxB;IACI,yBAAyB,EAAE,4BAA4B;IACvD,aAAa;IACb,mBAAmB;IACnB,+CAA+C;IAC/C,gBAAgB;AACpB;;AAEA;IACI,gBAAgB;IAChB,cAAc;IACd,mBAAmB;IACnB,gBAAgB;AACpB;;AAEA;IACI,gBAAgB;IAChB,UAAU;IACV,aAAa;IACb,eAAe;IACf,uBAAuB;IACvB,QAAQ;IACR,iBAAiB,EAAE,+BAA+B;IAClD,gBAAgB;IAChB,8BAA8B;IAC9B,iBAAiB;IACjB,4BAA4B;IAC5B,qBAAqB,EAAE,YAAY;IACnC,gCAAgC,EAAE,YAAY;AAClD;;AAEA;IACI,UAAU;AACd;AACA;IACI,mBAAmB;IACnB,mBAAmB;AACvB;AACA;IACI,yBAAyB;IACzB,mBAAmB;IACnB,yBAAyB;AAC7B;;AAEA;IACI,yBAAyB,EAAE,oBAAoB;IAC/C,cAAc;IACd,iBAAiB;IACjB,mBAAmB;IACnB,iBAAiB;IACjB,gBAAgB;IAChB,yCAAyC;IACzC,0BAA0B;AAC9B;;AAEA,6BAA6B;AAC7B;IACI,eAAe;AACnB;;AAEA;IACI,gBAAgB;IAChB,cAAc,EAAE,QAAQ;IACxB,mBAAmB;IACnB,gBAAgB;IAChB,2CAA2C;AAC/C;;AAEA;IACI,gBAAgB;IAChB,cAAc;IACd,mBAAmB;AACvB;;AAEA;IACI,gBAAgB;IAChB,cAAc,EAAE,SAAS;IACzB,gBAAgB;AACpB;;AAEA;IACI,gBAAgB;AACpB;;AAEA,2BAA2B;AAC3B;IACI;QACI,cAAc;IAClB;IACA;QACI,aAAa;IACjB;IACA;QACI,cAAc;IAClB;IACA;QACI,gBAAgB;IACpB;IACA;QACI,gBAAgB;QAChB,eAAe;QACf,YAAY;IAChB;IACA;QACI,gBAAgB;QAChB,kBAAkB;IACtB;IACA;QACI,gBAAgB;QAChB,kBAAkB;IACtB;IACA;QACI,gBAAgB;IACpB;AACJ;;AAEA;IACI;QACI,aAAa;IACjB;IACA;QACI,gBAAgB;QAChB,mBAAmB;IACvB;IACA;QACI,aAAa;IACjB;IACA;QACI,sBAAsB;QACtB,QAAQ;IACZ;IACA;QACI,gBAAgB;IACpB;IACA;QACI,gBAAgB;IACpB;IACA;QACI,gBAAgB;QAChB,eAAe;QACf,YAAY;IAChB;IACA;QACI,UAAU;IACd;IACA;QACI,sBAAsB;QACtB,SAAS;IACb;IACA;QACI,WAAW;QACX,gBAAgB;IACpB;IACA;QACI,cAAc;IAClB;AACJ;;;;;;;AAOA,2IAA2I;;;;;AAK3I,uCAAuC;;AAGvC;IACI,mBAAmB,EAAE,+BAA+B;IACpD,wBAAwB,EAAE,6BAA6B;IACvD,0BAA0B,EAAE,8BAA8B;IAC1D,uBAAuB;IACvB,wBAAwB;IACxB,kBAAkB;IAClB,0BAA0B,EAAE,iCAAiC;IAC7D,8BAA8B;IAC9B,kCAAkC;AACtC;;;;AAIA,gCAAgC;AAChC;;IAEI,kBAAkB;OACf,aAAa;IAChB,sBAAsB;IACtB,mBAAmB;IACnB,aAAa;IACb,sBAAsB;IACtB,WAAW;IACX,iBAAiB;AACrB;;AAEA;IACI,iBAAiB;IACjB,gBAAgB;IAChB,2BAA2B;IAC3B,mBAAmB;IACnB,4CAA4C;AAChD;;AAEA;IACI,mCAAmC;IACnC,cAAc;IACd,mBAAmB;IACnB,2CAA2C;IAC3C,iBAAiB,EAAE,6BAA6B;IAChD,aAAa;IACb,sBAAsB;IACtB,uBAAuB;AAC3B;;AAEA,sCAAsC;AACtC;IACI,aAAa;IACb,sBAAsB;IACtB,mBAAmB;IACnB,uBAAuB;IACvB,kCAAkC;AACtC;;AAEA;IACI,eAAe;IACf,gBAAgB;IAChB,mBAAmB;AACvB;;AAEA;IACI,iBAAiB;IACjB,mBAAmB;AACvB;;AAEA;IACI,mBAAmB;IACnB,kBAAkB;IAClB,mBAAmB;IACnB,mBAAmB;IACnB,gBAAgB;AACpB;;AAEA;IACI,aAAa;IACb,iBAAiB;AACrB;;;AAGA,iCAAiC;AACjC;IACI,aAAa;IACb,SAAS;IACT,mBAAmB;AACvB;;AAEA;IACI,mBAAmB;IACnB,6BAA6B;IAC7B,mBAAmB;IACnB,kBAAkB;IAClB,eAAe;IACf,gBAAgB;IAChB,eAAe;IACf,yBAAyB;AAC7B;;AAEA;IACI,mBAAmB;AACvB;;AAEA;IACI,wCAAwC;IACxC,8BAA8B;IAC9B,oCAAoC;AACxC;;AAEA;IACI,kBAAkB;IAClB,cAAc;IACd,gBAAgB,EAAE,yBAAyB;IAC3C,mBAAmB;AACvB;;;AAGA,oBAAoB;AACpB;IACI,sCAAsC;IACtC,8BAA8B;IAC9B,YAAY;IACZ,mBAAmB;IACnB,kBAAkB;IAClB,iBAAiB;IACjB,gBAAgB;IAChB,eAAe;IACf,2DAA2D;AAC/D;;AAEA;IACI,yBAAyB;IACzB,2BAA2B;AAC/B;;AAEA;IACI,mBAAmB;IACnB,6BAA6B;IAC7B,yBAAyB;IACzB,kBAAkB;IAClB,iBAAiB;IACjB,gBAAgB;IAChB,eAAe;IACf,sCAAsC;AAC1C;;AAEA;IACI,yBAAyB;AAC7B;;AAEA,0BAA0B;AAC1B;IACI,aAAa;IACb,8BAA8B;IAC9B,mBAAmB;IACnB,eAAe;IACf,mBAAmB;IACnB,iBAAiB;AACrB;;AAEA;IACI,gBAAgB;IAChB,2BAA2B;AAC/B;;AAEA,oCAAoC;AACpC;IACI,aAAa;IACb,SAAS;IACT,uBAAuB;AAC3B;;AAEA;IACI,mBAAmB,EAAE,2BAA2B;AACpD;;AAEA;IACI,kBAAkB;IAClB,WAAW;IACX,mBAAmB,EAAE,iCAAiC;IACtD,4BAA4B;IAC5B,uDAAuD;IACvD,gBAAgB;IAChB,YAAY;IACZ,UAAU;IACV,eAAe;AACnB;;AAEA;IACI,0BAA0B;AAC9B;;AAEA;IACI,kBAAkB;IAClB,WAAW;IACX,YAAY;IACZ,2BAA2B;IAC3B,mCAAmC,EAAE,WAAW;IAChD,aAAa;IACb,uBAAuB;IACvB,mBAAmB;IACnB,mBAAmB;IACnB,yCAAyC;IACzC,eAAe,EAAE,2BAA2B;AAChD;;AAEA;IACI,iFAAiF;IACjF,8BAA8B;AAClC;;AAEA;IACI,gCAAgC;IAChC,6BAA6B;IAC7B,0BAA0B;AAC9B;;AAEA,wBAAwB;AACxB;IACI,wCAAwC;IACxC,4CAA4C;IAC5C,cAAc,EAAE,0BAA0B;IAC1C,sCAAsC,EAAE,sBAAsB;IAC9D,2DAA2D;AAC/D;;AAEA;IACI,mBAAmB;IACnB,YAAY;AAChB;;AAEA,8DAA8D;AAC9D;IACI;QACI,iBAAiB;IACrB;IACA;QACI,eAAe;IACnB;IACA;QACI,aAAa;IACjB;AACJ;;AAEA;IACI;QACI,aAAa;IACjB;IACA;QACI,iBAAiB;IACrB;KACC;QACG,sBAAsB;IAC1B;IACA;QACI,sBAAsB;QACtB,SAAS;QACT,mBAAmB;IACvB;AACJ;;AAEA,uBAAuB;AACvB;IACI;QACI,UAAU;QACV,2BAA2B;IAC/B;IACA;QACI,UAAU;QACV,wBAAwB;IAC5B;AACJ","sourcesContent":["\n\n.word-wizard-game-container {\n    display: flex;\n    flex-direction: column;\n    align-items: center;\n    padding: 30px;\n    max-width: 850px;\n    width: 100%;\n    margin: 20px auto;\n}\n\n.game-main-title {\n    font-family: 'Montserrat', sans-serif; /* Distinctive title font */\n    font-size: 3.8em;\n    font-weight: 700;\n    color: #2c3e50; /* Deep blue */\n    text-shadow: 2px 2px 5px rgba(0, 0, 0, 0.1);\n    margin-bottom: 30px;\n    letter-spacing: 1.5px;\n}\n\n.game-board-panel {\n    background-color: #ffffff;\n    border-radius: 15px;\n    box-shadow: 0 10px 30px rgba(0, 0, 0, 0.1);\n    padding: 40px;\n    width: 100%;\n    text-align: center;\n    position: relative;\n    overflow: hidden;\n}\n\n/* Subtle gradient border effect */\n.game-board-panel::before {\n    content: '';\n    position: absolute;\n    top: 0;\n    left: 0;\n    right: 0;\n    bottom: 0;\n    border-radius: 15px;\n    padding: 4px; /* Thickness of the border */\n    background: linear-gradient(45deg, #42a5f5, #26a69a); /* Blue-green gradient */\n    -webkit-mask:\n       linear-gradient(#fff 0 0) content-box,\n       linear-gradient(#fff 0 0);\n    -webkit-mask-composite: xor;\n    mask-composite: exclude;\n    z-index: -1;\n}\n\n/* --- Common Button Styles --- */\n.primary-button, .action-button, .difficulty-button, .letter-tile {\n    font-family: 'Montserrat', sans-serif;\n    font-weight: 600;\n    border: none;\n    padding: 12px 25px;\n    border-radius: 8px;\n    cursor: pointer;\n    transition: all 0.2s ease;\n    text-transform: uppercase;\n    letter-spacing: 0.5px;\n}\n\n.primary-button {\n    background-color: #28a745; /* Green */\n    color: white;\n    font-size: 1.2em;\n    box-shadow: 0 4px 10px rgba(40, 167, 69, 0.3);\n}\n\n.primary-button:hover {\n    background-color: #218838; /* Darker green */\n    transform: translateY(-2px);\n    box-shadow: 0 6px 15px rgba(40, 167, 69, 0.4);\n}\n\n.primary-button:active {\n    transform: translateY(1px);\n    box-shadow: 0 2px 5px rgba(40, 167, 69, 0.2);\n}\n\n.action-button {\n    background-color: #42a5f5; /* Light blue */\n    color: white;\n    font-size: 1em;\n    box-shadow: 0 3px 8px rgba(66, 165, 245, 0.3);\n}\n\n.action-button:hover {\n    background-color: #2196f3; /* Darker blue */\n    transform: translateY(-1px);\n    box-shadow: 0 4px 12px rgba(66, 165, 245, 0.4);\n}\n\n.action-button:active {\n    transform: translateY(0);\n    box-shadow: 0 1px 3px rgba(66, 165, 245, 0.2);\n}\n\n/* --- Game Menu --- */\n.game-menu-screen {\n    padding: 20px 0;\n}\n\n.menu-title {\n    font-size: 2.2em;\n    color: #26a69a; /* Teal */\n    margin-bottom: 25px;\n    font-weight: 600;\n}\n\n.difficulty-options {\n    display: flex;\n    justify-content: center;\n    gap: 15px;\n    margin-bottom: 30px;\n    flex-wrap: wrap;\n}\n\n.difficulty-button {\n    background-color: #bdbdbd; /* Light gray */\n    color: #555;\n    font-size: 1.1em;\n    padding: 10px 20px;\n    box-shadow: 0 2px 5px rgba(0, 0, 0, 0.1);\n}\n\n.difficulty-button:hover {\n    background-color: #9e9e9e; /* Medium gray */\n    transform: translateY(-1px);\n}\n\n.difficulty-button.active {\n    background-color: #42a5f5; /* Active blue */\n    color: white;\n    box-shadow: 0 3px 8px rgba(66, 165, 245, 0.3);\n    transform: translateY(0);\n}\n.difficulty-button.active:hover {\n    background-color: #42a5f5; /* No change on hover for active */\n}\n\n.difficulty-description {\n    font-size: 1em;\n    color: #616161;\n    margin-bottom: 40px;\n    line-height: 1.5;\n}\n\n/* --- Game Active Area --- */\n.game-active-area {\n    padding: 0 10px;\n}\n\n.game-header-stats {\n    display: flex;\n    justify-content: space-around;\n    margin-bottom: 30px;\n    background-color: #eceff1; /* Very light blue-gray */\n    padding: 15px 20px;\n    border-radius: 10px;\n    box-shadow: inset 0 1px 5px rgba(0, 0, 0, 0.05);\n}\n\n.stat-box {\n    display: flex;\n    flex-direction: column;\n    align-items: center;\n}\n\n.stat-label {\n    font-size: 0.9em;\n    color: #78909c;\n    margin-bottom: 5px;\n    font-weight: 400;\n}\n\n.stat-value {\n    font-size: 1.8em;\n    font-weight: 700;\n    color: #26a69a; /* Teal */\n}\n\n.timer-box .stat-value.time-critical {\n    color: #ef5350; /* Red */\n    animation: pulse-warn 1s infinite alternate;\n}\n\n@keyframes pulse-warn {\n    from { opacity: 1; }\n    to { opacity: 0.7; }\n}\n\n/* Scrambled Letters Tray */\n.scrambled-letters-tray {\n    display: flex;\n    justify-content: center;\n    flex-wrap: wrap;\n    gap: 10px;\n    margin-bottom: 30px;\n    min-height: 70px; /* To prevent layout jump */\n}\n\n.letter-tile {\n    background-color: #bbdefb; /* Lighter blue */\n    color: #1e88e5; /* Darker blue text */\n    font-size: 1.8em;\n    min-width: 55px;\n    height: 55px;\n    display: flex;\n    align-items: center;\n    justify-content: center;\n    padding: 0;\n    border-radius: 8px;\n    box-shadow: 0 2px 5px rgba(0, 0, 0, 0.1);\n    font-weight: 700;\n}\n\n.letter-tile:hover:not(:disabled) {\n    background-color: #90caf9; /* Even lighter blue */\n    transform: translateY(-2px);\n    box-shadow: 0 4px 8px rgba(0, 0, 0, 0.2);\n}\n\n.letter-tile.used {\n    background-color: #e0e0e0; /* Gray for used letters */\n    color: #9e9e9e;\n    cursor: not-allowed;\n    opacity: 0.7;\n    transform: none;\n    box-shadow: none;\n}\n\n/* Word Input Controls */\n.word-input-controls {\n    display: flex;\n    flex-direction: column;\n    align-items: center;\n    margin-bottom: 25px;\n}\n\n.word-input-field {\n    width: 80%;\n    max-width: 400px;\n    padding: 12px 18px;\n    margin-bottom: 15px;\n    border: 1px solid #cfd8dc;\n    border-radius: 8px;\n    font-size: 1.2em;\n    text-align: center;\n    outline: none;\n    transition: border-color 0.3s ease, box-shadow 0.3s ease;\n    color: #34495e;\n    text-transform: uppercase;\n    font-weight: 400;\n}\n\n.word-input-field::placeholder {\n    color: #b0bec5;\n    font-weight: 300;\n}\n\n.word-input-field:focus {\n    border-color: #42a5f5;\n    box-shadow: 0 0 0 3px rgba(66, 165, 245, 0.2);\n}\n\n.input-action-buttons {\n    display: flex;\n    gap: 15px;\n    flex-wrap: wrap;\n    justify-content: center;\n}\n\n.submit-button {\n    background-color: #66bb6a; /* Green */\n}\n.submit-button:hover {\n    background-color: #43a047; /* Darker green */\n}\n\n.clear-button {\n    background-color: #90a4ae; /* Gray */\n}\n.clear-button:hover {\n    background-color: #78909c; /* Darker gray */\n}\n\n/* Game Feedback Messages */\n.game-feedback-message {\n    font-size: 1.1em;\n    padding: 10px 20px;\n    border-radius: 6px;\n    margin-bottom: 20px;\n    min-height: 25px; /* Maintain space */\n    transition: background-color 0.3s ease, color 0.3s ease;\n    font-weight: 500;\n}\n\n.game-feedback-message.success {\n    background-color: #e8f5e9; /* Light green background */\n    color: #28a745;\n    border: 1px solid #a5d6a7;\n}\n\n.game-feedback-message.warning {\n    background-color: #fffde7; /* Light yellow background */\n    color: #ffc107;\n    border: 1px solid #ffe082;\n}\n\n.game-feedback-message.error {\n    background-color: #ffebee; /* Light red background */\n    color: #ef5350;\n    border: 1px solid #ef9a9a;\n}\n\n/* Found Words Display */\n.found-words-display {\n    background-color: #f5f5f5; /* Lighter gray background */\n    padding: 20px;\n    border-radius: 10px;\n    box-shadow: inset 0 1px 5px rgba(0, 0, 0, 0.03);\n    margin-top: 25px;\n}\n\n.found-words-title {\n    font-size: 1.5em;\n    color: #2c3e50;\n    margin-bottom: 15px;\n    font-weight: 600;\n}\n\n.found-words-list-scroll {\n    list-style: none;\n    padding: 0;\n    display: flex;\n    flex-wrap: wrap;\n    justify-content: center;\n    gap: 8px;\n    max-height: 120px; /* Fixed height for scrolling */\n    overflow-y: auto;\n    border-top: 1px dashed #cfd8dc;\n    padding-top: 15px;\n    /* Custom scrollbar styles */\n    scrollbar-width: thin; /* Firefox */\n    scrollbar-color: #90a4ae #f5f5f5; /* Firefox */\n}\n\n.found-words-list-scroll::-webkit-scrollbar {\n    width: 8px;\n}\n.found-words-list-scroll::-webkit-scrollbar-track {\n    background: #f5f5f5;\n    border-radius: 10px;\n}\n.found-words-list-scroll::-webkit-scrollbar-thumb {\n    background-color: #90a4ae;\n    border-radius: 10px;\n    border: 2px solid #f5f5f5;\n}\n\n.found-word-item {\n    background-color: #e0f2f7; /* Very light blue */\n    color: #2c3e50;\n    padding: 6px 12px;\n    border-radius: 15px;\n    font-size: 0.95em;\n    font-weight: 400;\n    box-shadow: 0 1px 3px rgba(0, 0, 0, 0.08);\n    text-transform: capitalize;\n}\n\n/* --- Game Over Screen --- */\n.game-over-screen {\n    padding: 30px 0;\n}\n\n.game-over-title {\n    font-size: 2.8em;\n    color: #ef5350; /* Red */\n    margin-bottom: 20px;\n    font-weight: 700;\n    text-shadow: 1px 1px 3px rgba(0, 0, 0, 0.1);\n}\n\n.final-summary {\n    font-size: 1.4em;\n    color: #34495e;\n    margin-bottom: 10px;\n}\n\n.final-score-value, .final-words-count-value {\n    font-weight: 700;\n    color: #26a69a; /* Teal */\n    font-size: 1.1em;\n}\n\n.play-again-button {\n    margin-top: 30px;\n}\n\n/* Responsive Adjustments */\n@media (max-width: 768px) {\n    .game-main-title {\n        font-size: 3em;\n    }\n    .game-board-panel {\n        padding: 30px;\n    }\n    .menu-title, .game-over-title {\n        font-size: 2em;\n    }\n    .stat-value {\n        font-size: 1.6em;\n    }\n    .letter-tile {\n        font-size: 1.5em;\n        min-width: 50px;\n        height: 50px;\n    }\n    .word-input-field {\n        font-size: 1.1em;\n        padding: 10px 15px;\n    }\n    .action-button {\n        font-size: 0.9em;\n        padding: 10px 20px;\n    }\n    .final-summary {\n        font-size: 1.2em;\n    }\n}\n\n@media (max-width: 480px) {\n    .word-wizard-game-container {\n        padding: 15px;\n    }\n    .game-main-title {\n        font-size: 2.2em;\n        margin-bottom: 20px;\n    }\n    .game-board-panel {\n        padding: 20px;\n    }\n    .difficulty-options {\n        flex-direction: column;\n        gap: 8px;\n    }\n    .menu-title, .game-over-title {\n        font-size: 1.6em;\n    }\n    .stat-value {\n        font-size: 1.4em;\n    }\n    .letter-tile {\n        font-size: 1.2em;\n        min-width: 45px;\n        height: 45px;\n    }\n    .word-input-field {\n        width: 95%;\n    }\n    .input-action-buttons {\n        flex-direction: column;\n        gap: 10px;\n    }\n    .action-button {\n        width: 100%;\n        max-width: 180px;\n    }\n    .final-summary {\n        font-size: 1em;\n    }\n}\n\n\n\n\n\n\n/*    ========================================================= memory match css========================================================= */\n\n\n\n\n/* --- Global Styles & Typography --- */\n@import url('https://fonts.googleapis.com/css2?family=Poppins:wght@400;600;700&display=swap');\n\n:root {\n    --bg-color: #f0f4f8; /* Light blue-gray background */\n    --primary-color: #4a90e2; /* A friendly, vibrant blue */\n    --secondary-color: #50e3c2; /* A complementary teal/mint */\n    --dark-text-color: #333;\n    --light-text-color: #fff;\n    --card-bg: #ffffff;\n    --card-matched-bg: #d4edda; /* Soft green for matched cards */\n    --card-matched-border: #b2d8b6;\n    --shadow-color: rgba(0, 0, 0, 0.1);\n}\n\n\n\n/* --- Main Game Container --- */\n.memory-match-container {\n   \n    text-align: center;\n       display: flex;\n    flex-direction: column;\n    align-items: center;\n    padding: 30px;\n    /* max-width: 850px; */\n    width: 100%;\n    margin: 20px auto;\n}\n\n.game-title {\n    font-size: 2.5rem;\n    font-weight: 700;\n    color: var(--primary-color);\n    margin-bottom: 20px;\n    text-shadow: 1px 1px 2px var(--shadow-color);\n}\n\n.game-board {\n    background: var(--light-text-color);\n    padding: 100px;\n    border-radius: 20px;\n    box-shadow: 0 10px 30px var(--shadow-color);\n    min-height: 500px; /* Ensure consistent height */\n    display: flex;\n    flex-direction: column;\n    justify-content: center;\n}\n\n/* --- Game Screens (Menu & Win) --- */\n.game-screen {\n    display: flex;\n    flex-direction: column;\n    align-items: center;\n    justify-content: center;\n    animation: fadeIn 0.5s ease-in-out;\n}\n\n.screen-title {\n    font-size: 2rem;\n    font-weight: 600;\n    margin-bottom: 20px;\n}\n\n.win-message {\n    font-size: 1.2rem;\n    margin-bottom: 20px;\n}\n\n.win-stats {\n    background: #f9f9f9;\n    padding: 15px 30px;\n    border-radius: 10px;\n    margin-bottom: 30px;\n    text-align: left;\n}\n\n.win-stats p {\n    margin: 8px 0;\n    font-size: 1.1rem;\n}\n\n\n/* --- Difficulty Selection --- */\n.difficulty-options {\n    display: flex;\n    gap: 15px;\n    margin-bottom: 20px;\n}\n\n.difficulty-button {\n    background: #e9ecef;\n    border: 2px solid transparent;\n    border-radius: 10px;\n    padding: 12px 25px;\n    font-size: 1rem;\n    font-weight: 600;\n    cursor: pointer;\n    transition: all 0.3s ease;\n}\n\n.difficulty-button:hover {\n    background: #dde2e6;\n}\n\n.difficulty-button.active {\n    background-color: var(--secondary-color);\n    color: var(--light-text-color);\n    border-color: var(--secondary-color);\n}\n\n.difficulty-description {\n    font-style: italic;\n    color: #6c757d;\n    min-height: 40px; /* Prevent layout shift */\n    margin-bottom: 25px;\n}\n\n\n/* --- Buttons --- */\n.primary-button {\n    background-color: var(--primary-color);\n    color: var(--light-text-color);\n    border: none;\n    border-radius: 10px;\n    padding: 15px 40px;\n    font-size: 1.1rem;\n    font-weight: 600;\n    cursor: pointer;\n    transition: background-color 0.3s ease, transform 0.2s ease;\n}\n\n.primary-button:hover {\n    background-color: #3a7ac8;\n    transform: translateY(-2px);\n}\n\n.secondary-button {\n    background: #f8f9fa;\n    color: var(--dark-text-color);\n    border: 1px solid #dee2e6;\n    border-radius: 8px;\n    padding: 8px 16px;\n    font-weight: 600;\n    cursor: pointer;\n    transition: background-color 0.3s ease;\n}\n\n.secondary-button:hover {\n    background-color: #e9ecef;\n}\n\n/* --- Game Info Bar --- */\n.game-info-bar {\n    display: flex;\n    justify-content: space-between;\n    align-items: center;\n    padding: 0 10px;\n    margin-bottom: 25px;\n    font-size: 1.1rem;\n}\n\n.info-value {\n    font-weight: 700;\n    color: var(--primary-color);\n}\n\n/* --- Card Grid & Card Styles --- */\n.card-grid {\n    display: grid;\n    gap: 15px;\n    justify-content: center;\n}\n\n.card-container {\n    perspective: 1000px; /* For the 3D flip effect */\n}\n\n.card-inner {\n    position: relative;\n    width: 100%;\n    aspect-ratio: 1 / 1; /* Makes cards perfectly square */\n    transform-style: preserve-3d;\n    transition: transform 0.6s cubic-bezier(0.4, 0, 0.2, 1);\n    background: none;\n    border: none;\n    padding: 0;\n    cursor: pointer;\n}\n\n.card-inner.is-flipped {\n    transform: rotateY(180deg);\n}\n\n.card-face {\n    position: absolute;\n    width: 100%;\n    height: 100%;\n    backface-visibility: hidden;\n    -webkit-backface-visibility: hidden; /* Safari */\n    display: flex;\n    justify-content: center;\n    align-items: center;\n    border-radius: 10px;\n    box-shadow: 0 4px 8px var(--shadow-color);\n    font-size: 2rem; /* Default size for icons */\n}\n\n.card-back {\n    background: linear-gradient(135deg, var(--primary-color), var(--secondary-color));\n    color: var(--light-text-color);\n}\n\n.card-front {\n    background-color: var(--card-bg);\n    color: var(--dark-text-color);\n    transform: rotateY(180deg);\n}\n\n/* Matched Card Styles */\n.card-inner.is-matched .card-front {\n    background-color: var(--card-matched-bg);\n    border: 2px solid var(--card-matched-border);\n    color: #388e3c; /* Darker green for icon */\n    transform: rotateY(180deg) scale(1.05); /* Slight pop effect */\n    transition: background-color 0.3s ease, transform 0.3s ease;\n}\n\n.card-inner.is-matched {\n    cursor: not-allowed;\n    opacity: 0.8;\n}\n\n/* Adjust font size for smaller cards in harder difficulties */\n@media (max-width: 768px) {\n    .card-face {\n        font-size: 1.8rem;\n    }\n    .game-title {\n        font-size: 2rem;\n    }\n    .game-board {\n        padding: 20px;\n    }\n}\n\n@media (max-width: 480px) {\n    body {\n        padding: 10px;\n    }\n    .card-face {\n        font-size: 1.5rem;\n    }\n     .difficulty-options {\n        flex-direction: column;\n    }\n    .game-info-bar {\n        flex-direction: column;\n        gap: 10px;\n        margin-bottom: 20px;\n    }\n}\n\n/* --- Animations --- */\n@keyframes fadeIn {\n    from {\n        opacity: 0;\n        transform: translateY(10px);\n    }\n    to {\n        opacity: 1;\n        transform: translateY(0);\n    }\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
